module.exports = __webpack_public_path__ + "img/mh.8f1f9134.svg";